import React from 'react';
import { Section } from '../ui/Section';
import { CheckCircle } from 'lucide-react';
export function ResumenValor() {
  return <Section background="white" data-id="element-263">
      <div className="bg-stone-50 border border-stone-200 rounded-2xl p-8 md:p-12" data-id="element-264">
        <h2 className="text-3xl font-bold text-center mb-8 text-stone-900" data-id="element-265">
          Resumen: lo que recibís hoy
        </h2>

        <div className="space-y-4 mb-10 max-w-lg mx-auto" data-id="element-266">
          <div className="flex items-center justify-between border-b border-stone-200 pb-3" data-id="element-267">
            <span className="flex items-center gap-2 font-medium" data-id="element-268">
              <CheckCircle className="w-5 h-5 text-emerald-600" data-id="element-269" /> Semana
              Resuelta (PDF)
            </span>
            <span className="text-stone-900 font-bold" data-id="element-270">Incluido</span>
          </div>
          <div className="flex items-center justify-between border-b border-stone-200 pb-3 text-stone-600" data-id="element-271">
            <span className="flex items-center gap-2" data-id="element-272">
              <CheckCircle className="w-5 h-5 text-emerald-600" data-id="element-273" /> Bono 1:
              Domingo Cerrado
            </span>
            <span className="text-stone-400 line-through" data-id="element-274">ARS 47.000</span>
          </div>
          <div className="flex items-center justify-between border-b border-stone-200 pb-3 text-stone-600" data-id="element-275">
            <span className="flex items-center gap-2" data-id="element-276">
              <CheckCircle className="w-5 h-5 text-emerald-600" data-id="element-277" /> Bono 2: Swaps
              Inteligentes
            </span>
            <span className="text-stone-400 line-through" data-id="element-278">ARS 47.000</span>
          </div>
          <div className="flex items-center justify-between border-b border-stone-200 pb-3 text-stone-600" data-id="element-279">
            <span className="flex items-center gap-2" data-id="element-280">
              <CheckCircle className="w-5 h-5 text-emerald-600" data-id="element-281" /> Bono 3:
              Salvavidas 10 Min
            </span>
            <span className="text-stone-400 line-through" data-id="element-282">ARS 47.000</span>
          </div>
        </div>

        <div className="text-center" data-id="element-283">
          <p className="text-stone-500 text-lg mb-2" data-id="element-284">
            Valor total: <span className="line-through" data-id="element-285">ARS 150.990</span>
          </p>
          <p className="text-4xl md:text-5xl font-extrabold text-stone-900 mb-6" data-id="element-286">
            Hoy: ARS 9.990
          </p>
          <p className="text-stone-600 italic" data-id="element-287">
            Sí. Es real. Y sí, los bonos son gratis porque queremos que el
            sistema funcione de verdad.
          </p>
        </div>
      </div>
    </Section>;
}